function attributeToString(e) {
  return "string" != typeof e && (e += "", "undefined" === e && (e = "")), jQuery.trim(e)
}
"undefined" == typeof window.Shopify && (window.Shopify = {}),

Shopify.KT_onError = function(e, t) {
  $('.btn.loading, .kt-button.loading').removeClass('loading');
  var n = {};
  try { n = JSON.parse(e.responseText) || {} } catch (err) {}
  var text = n.description || n.message || "";
  if (/maximum quantity|already in your cart|are in your cart|in stock/i.test(text)) {
    return Shopify.KT_notice({ title: "Already in your basket", text: "You’ve added the maximum quantity available.", basketLink: true })
  }
  if (!text && typeof n === "object" && Object.keys(n).length) {
    text = Shopify.KT_fullMessagesFromErrors(n).join(". ")
  }
  Shopify.KT_notice({ text: text || "Sorry, we couldn't add this to your basket. Please try again." })
},
Shopify.KT_notice = function(opts) {
  if (!document.getElementById("gdc-notice-css")) {
    var s = document.createElement("style");
    s.id = "gdc-notice-css";
    s.textContent =
      ".gdc-notice{position:fixed;left:50%;top:calc(16px + env(safe-area-inset-top));z-index:2147483000;display:flex;align-items:flex-start;gap:12px;" +
      "width:calc(100% - 32px);max-width:420px;padding:14px 14px 14px 16px;box-sizing:border-box;background:#fff;color:#1f2933;" +
      "border-radius:10px;border-left:4px solid var(--gdc-m-green,#0b5d4b);box-shadow:0 8px 28px rgba(0,0,0,.18);" +
      "font-size:14px;line-height:1.45;opacity:0;transform:translate(-50%,-12px);transition:opacity .2s,transform .2s}" +
      ".gdc-notice.is-open{opacity:1;transform:translate(-50%,0)}" +
      ".gdc-notice__body{flex:1;min-width:0}" +
      ".gdc-notice__title{margin:0 0 2px;font-size:15px;font-weight:600;color:#111827}" +
      ".gdc-notice__text{margin:0}" +
      ".gdc-notice__link{display:inline-block;margin-top:6px;font-weight:600;color:var(--gdc-m-green,#0b5d4b);text-decoration:underline;text-underline-offset:2px}" +
      ".gdc-notice__close{flex:none;width:24px;height:24px;margin:-2px -2px 0 0;padding:0;border:0;background:none;color:#6b7280;font-size:20px;line-height:1;cursor:pointer}";
    document.head.appendChild(s)
  }
  var old = document.querySelector(".gdc-notice");
  old && old.remove();
  var el = function(tag, cls, txt) {
    var x = document.createElement(tag);
    x.className = cls;
    if (txt) x.textContent = txt;
    return x
  };
  var box = el("div", "gdc-notice");
  box.setAttribute("role", "alert");
  var body = el("div", "gdc-notice__body");
  if (opts.title) body.appendChild(el("p", "gdc-notice__title", opts.title));
  body.appendChild(el("p", "gdc-notice__text", opts.text));
  var x = el("button", "gdc-notice__close", "×");
  x.type = "button";
  x.setAttribute("aria-label", "Close");
  var close = function() {
    box.classList.remove("is-open");
    setTimeout(function() { box.remove() }, 200)
  };
  if (opts.basketLink) {
    var a = el("a", "gdc-notice__link", "View basket");
    a.href = (Shopify.root_url || "") + "/cart";
    a.addEventListener("click", function(ev) {
      var drawer = document.getElementById("cartOffcanvas");
      if (drawer && window.jQuery && jQuery.fn.offcanvas) {
        ev.preventDefault();
        close();
        jQuery(drawer).offcanvas("show")
      }
    });
    body.appendChild(a)
  }
  box.appendChild(body);
  box.appendChild(x);
  document.body.appendChild(box);
  x.addEventListener("click", close);
  requestAnimationFrame(function() { box.classList.add("is-open") });
  setTimeout(close, opts.basketLink ? 7000 : 5000)
},
Shopify.KT_fullMessagesFromErrors = function(e) {
  var t = [];
  return jQuery.each(e, function(e, n) {
    jQuery.each(n, function(n, r) {
      t.push(e + " " + r)
    })
  }), t
},
Shopify.KT_onCartUpdate = function(e,remove) {
  // alert("There are now " + e.item_count + " items in the cart."); 
  Shopify.KT_onCartUpdate_(e,remove);
},
Shopify.KT_onCartShippingRatesUpdate = function(e, t) {
  var n = "";
  t.zip && (n += t.zip + ", "), t.province && (n += t.province + ", "), n += t.country;
},
Shopify.KT_onItemAdded = function(e) {
  // Shopify.Cart.alert(e, true)
  Shopify.KT_getCart();
},
Shopify.KT_addItem = function(e, t, n) {
  var itemChange = e;
  var t = t || 1,
      r = {
        type: "POST",
        url: Shopify.root_url+"/cart/add.js",
        data: "quantity=" + t + "&id=" + e,
        dataType: "json",
        success: function(e) {
          "function" == typeof n ? n(itemChange,e) : Shopify.KT_onItemAdded(e)
        },
        error: function(e, t) {
          Shopify.KT_onError(e, t)
        }
      };
  jQuery.ajax(r)
},
Shopify.KT_addItems = function(items, callback) {
  var ajax = {
        type: "POST",
        url: Shopify.root_url+"/cart/add.js",
        data: {'items': items},
        dataType: "json",
        success: function(data) {
          "function" == typeof callback ? callback(items) : Shopify.KT_onItemAdded(data)
        },
        error: function(data, t) {
          Shopify.KT_onError(data, t)
        }
      };
  jQuery.ajax(ajax)
},
Shopify.KT_addItemFromForm = function(e, t) {
  // console.log(jQuery("#" + e).serialize());
  var n = {
    type: "POST",
    url: Shopify.root_url+"/cart/add.js",
    data: jQuery("#" + e).serialize(),
    dataType: "json",
    success: function(e) {
      "function" == typeof t ? t(e) : Shopify.KT_onItemAdded(e)
    },
    error: function(e, t) {
      Shopify.KT_onError(e, t)
    }
  };
  jQuery.ajax(n)
},
Shopify.KT_addItemsFromForm = function(el) {
  var n = {
      type: "POST",
      url: Shopify.root_url+"/cart/update.js",
      data: $(el).serialize(),
      dataType: "json",
      success: function(e) {
        "function" == typeof t ? t(e) : Shopify.KT_onCartUpdate(e);
      },
      error: function(e, t) {
        Shopify.KT_onError(e, t)
      }
  };
  jQuery.ajax(n)
},
Shopify.KT_getCart = function(e) {
  jQuery.getJSON(Shopify.root_url+"/cart.js", function(t, n) {
    "function" == typeof e ? e(t) : Shopify.KT_onCartUpdate(t)
  })
},
Shopify.KT_changeItem = function(e, t, n) {
  var itemChange = e;
  var r = {
      type: "POST",
      url: Shopify.root_url+"/cart/change.js",
      data: "quantity=" + t + "&id=" + e,
      dataType: "json",
      success: function(e) {
        "function" == typeof n ? n(itemChange,e) : Shopify.KT_onCartUpdate(e)
      },
      error: function(e, t) {
        Shopify.KT_onError(e, t)
      }
  };
  jQuery.ajax(r)
},
Shopify.KT_removeItem = function(e, t) {
  var itemChange = e;
  var n = {
      type: "POST",
      url: Shopify.root_url+"/cart/change.js",
      data: "quantity=0&id=" + e,
      dataType: "json",
      success: function(e) {
        "function" == typeof t ? t(itemChange,e,'remove item') : Shopify.KT_onCartUpdate(e,'remove item')
      },
      error: function(e, t) {
        Shopify.KT_onError(e, t)
      }
  };
  jQuery.ajax(n)
},
Shopify.KT_clear = function(e) {
  var t = {
      type: "POST",
      url: Shopify.root_url+"/cart/clear.js",
      data: "",
      dataType: "json",
      success: function(t) {
        "function" == typeof e ? e(t) : Shopify.KT_onCartUpdate(t)
      },
      error: function(e, t) {
        Shopify.KT_onError(e, t)
      }
  };
  jQuery.ajax(t)
},
Shopify.KT_updateCartAttributes = function(e, t) {
  var n = "";
  jQuery.isArray(e) ? jQuery.each(e, function(e, t) {
      var r = attributeToString(t.key);
      "" !== r && (n += "attributes[" + r + "]=" + attributeToString(t.value) + "&")
  }) : "object" == typeof e && null !== e && jQuery.each(e, function(e, t) {
      n += "attributes[" + attributeToString(e) + "]=" + attributeToString(t) + "&"
  });
  var r = {
      type: "POST",
      url: Shopify.root_url+"/cart/update.js",
      data: n,
      dataType: "json",
      success: function(e) {
        "function" == typeof t ? t(e) : Shopify.KT_onCartUpdate(e)
      },
      error: function(e, t) {
        Shopify.KT_onError(e, t)
      }
  };
  jQuery.ajax(r)
},
Shopify.KT_updateCartNote = function(e, t) {
  var n = {
      type: "POST",
      url: Shopify.root_url+"/cart/update.js",
      data: "note=" + attributeToString(e),
      dataType: "json",
      success: function(cart) {
        "function" == typeof t ? t(cart) : Shopify.KT_onCartUpdate(cart);
        if (cart.note !== '') {
          $('[data-tab-content="tab-floating-note"]').addClass('has-data');
        } else {          
          $('[data-tab-content="tab-floating-note"]').removeClass('has-data');
        }
      },
      error: function(e, t) {
        Shopify.KT_onError(e, t)
      }
  };
  jQuery.ajax(n)
},
Shopify.KT_updatedCartNote = function(cart) {
  $('.kt-button.loading').removeClass('loading');
  $('.cart-offcanvas__content').removeClass('show-tab-floating');
  $('.tab-floating-note').removeClass('active');
},
Shopify.KT_buildParams = function(e, t, n) {
    jQuery.isArray(t) && t.length ? jQuery.each(t, function(t, r) {
      rbracket.test(e) ? n(e, r) : Shopify.KT_buildParams(e + "[" + ("object" == typeof r || jQuery.isArray(r) ? t : "") + "]", r, n)
    }) : null != t && "object" == typeof t ? Shopify.KT_isEmptyObject(t) ? n(e, "") : jQuery.each(t, function(t, r) {
      Shopify.KT_buildParams(e + "[" + t + "]", r, n)
    }) : n(e, t)
},
Shopify.KT_isEmptyObject = function(e) {
  for (var t in e) return !1;
  return !0
},
Shopify.KT_addGift = function(cart){
  if($('[data-gift-auto-add]').length <= 0){return false}
  let option_data = JSON.parse($('[data-gift-auto-add]').html())
  if(!option_data && !option_data.id){return false}
  
  let alreadyExist = cart.items.filter(variant => variant.id == option_data.id);
  
  if(alreadyExist.length){
    if(cart.total_price < option_data.price_limit){
      Shopify.KT_removeItem(option_data.id)
    }else{
      return false
    }
  }
  
  if(cart && cart.total_price >= option_data.price_limit){
    let data = {
      id: option_data.id,
      quantity: 1
    }
    var n = {
      type: "POST",
      url: Shopify.root_url+"/cart/add.js",
      data: data,
      dataType: "json",
      success: function(e) {
        "function" == typeof t ? t(e) : Shopify.KT_onItemAdded(e)
      },
      error: function(e, t) {
        Shopify.KT_onError(e, t)
      }
    };
    jQuery.ajax(n)    
  } else {
    return false
  }
};

/* ----------- onClick customize for theme
---------------*/
$(document)
.on('click', '.add-item-jx', function(event){
  event.preventDefault();
  var $this = $(this);
  var id = $this.attr('data-vrid');
  var qty = 1;
  var $form = $this.parents('.form-ajax--');
  $this.find('.add-item-jx-text').attr('data-prev-text', $this.find('.add-item-jx-text').text()).addClass('waitting-text-change');
  if ($form.length > 0) {
    if($form.find('[name="id"]').length > 0){
      id = $form.find('[name="id"]').val();
    }
    if($form.find('[name="quantity"]').length > 0){
      qty = $form.find('[name="quantity"]').val();
    }
  }
  Shopify.KT_addItem(id,qty);
})
.on('click', '.addItemsAjax', function(event){
  event.preventDefault();
  Shopify.KT_addItemsFromForm('.addItemsAjaxFrom')
})
.on('click', '.mini-cart .act-remove', function(event){
  event.preventDefault();
  $('.mini-cart').addClass('loading');
  Shopify.KT_removeItem($(this).data('vrid'));
})
.on('click', '.cart-offcanvas .gdc-cart-clear', function(event){
  event.preventDefault();
  var btn = $(this);
  if (!btn.hasClass('is-confirm')) {
    btn.addClass('is-confirm').text('Confirm clear');
    clearTimeout(btn.data('t'));
    btn.data('t', setTimeout(function(){ btn.removeClass('is-confirm').text('Clear all') }, 3000));
    return;
  }
  clearTimeout(btn.data('t'));
  btn.removeClass('is-confirm').text('Clear all');
  $('.content__cart-offcanvas').addClass('loading');
  Shopify.KT_clear();
})
.on('click', '.cart-offcanvas .act-remove', function(event){
  event.preventDefault();
  $(this).parents('.item__cart').find('input').val(0).trigger('change');
})
.on('submit', '#upadteCartNote', function(event){
  event.preventDefault();
  $(this).find('.kt-button').addClass('loading');
  Shopify.KT_updateCartNote($('#upadteCartNote').find('textarea[name="note"]').val(),Shopify.KT_updatedCartNote);
})
.on('change', '#gift-wrapping', function(event) {
  event.preventDefault();
  event.stopPropagation();
  if ($(this).is(':checked')) {
    $('#gift-wrap_product').val(1).trigger('change');
  } else {      
    $('#gift-wrap_product').val(0).trigger('change');
  }
})
.on('change', '#upadteCartOffcanvas', function(event) {
  event.preventDefault();
  $('.content__cart-offcanvas').addClass('loading')
  Shopify.KT_addItemsFromForm('#upadteCartOffcanvas');
});

/* ----------- onCartUpdate customize for theme
---------------*/
Shopify.KT_onCartUpdate_ = function(cart,remove_action) {
  if (window.location.pathname.indexOf(Shopify.root_url+'/cart') == 0){
    location.reload();
    return false;
  }
  let GiftAdded =  Shopify.KT_addGift(cart);
  if(GiftAdded != false){return}

  var table = $(".ajax__list-cart");
  var table_content = '';
  $('.cartCount').text(cart.item_count);
  $('.cartCountItemx').text('(' + cart.item_count + ' ' + (cart.item_count == 1 ? theme.strings.cartItemText : theme.strings.cartItemsText) + ')');
  $('.cartCost').attr('data-price',cart.total_price).html(theme.Currency.formatMoney(cart.items_subtotal_price, theme.moneyFormat));
  if (cart.items_subtotal_price !== cart.total_price) {
    $('.cartSubTotalWrap').show();
  } else {
    $('.cartSubTotalWrap').hide();
  }
  $('.cartCostTotal').html(theme.Currency.formatMoney(cart.total_price, theme.moneyFormat));
  $('.title.has-item').html(cart.item_count == 1 ? theme.strings.cartItem.split('(')[0]+'('+cart.item_count+' '+theme.strings.cartItemText+')'+theme.strings.cartItem.split(')')[1] : theme.strings.cartItems.split('(')[0]+'('+cart.item_count+' '+theme.strings.cartItemsText+')'+theme.strings.cartItems.split(')')[1]);
  $('.btn.loading, .kt-button.loading').removeClass('loading');
  $('.waitting-text-change').text(theme.strings.addedToCart);
  $('.mini-cart .icon-link').removeClass('load');

  var iconCartVisible = function(){
    var cartVisible = false;
    if (theme.function.sticky_icon_cart === false) {return false}
    $('.cartCount:not(.fixed)').each(function(el,idx){
      if(this.getBoundingClientRect().top > 1){
        cartVisible = true;
      }
      if((idx + 1) === $('.cartCount:not(.fixed)').length) {
        return false;
      }
    });
    return cartVisible;
  }
  if (iconCartVisible() === false) {
    if (theme.function.type_ajax_cart === 'drop' || theme.function.type_ajax_cart === 'none') {
      $('body').addClass('popIn');
      anime({
        targets: '.cartCount.fixed',
        keyframes: [
          {backgroundColor: '#fff',color: '#555',scale: 1.25,rotate:-45,borderRadius:15},
          {backgroundColor: '#111',color: '#fff',scale: 1,rotate:0,borderRadius:50}
        ],
        duration: 2000,
        delay: 100,
        easing: 'easeOutElastic(1, .8)',
        compvare: function(anim) {
          $('.cartCount.fixed').removeAttr('style')
        }
      });
    }
  }
  if (theme.function.type_ajax_cart === 'none') {return}
  var urlAjax = Shopify.root_url+'/cart?view=listjsondrop';
  theme.function.type_ajax_cart == 'offcanvas' ? urlAjax = Shopify.root_url+'/cart?view=listjson' : urlAjax;
  theme.function.type_ajax_cart == 'popup' ? urlAjax = Shopify.root_url+'/cart?view=listjsonpopup' : urlAjax;
  if ($('#address_country').length > 0) {
    if($('#address_country option').length <= 0 ) {
      Shopify.Cart.getCountry();
    }
    if($('.get__shipping').attr('data-curr-address') !== undefined && cart.item_count > 0){
      $('.get__shipping').show();
      if ($('#address_country option').length > 0) {
        var address = JSON.parse($('.get__shipping').attr('data-curr-address'));
        Shopify.Cart.getCartShippingRates(address,Shopify.Cart.getShippingCart,Shopify.Cart.onError);
      }
    }
  }
  $.ajax({
    type: 'get',
    url: urlAjax,
    beforeSend: function() {
      if (cart.item_count > 0) {
        if ( $( ".has-item" ).is( ":hidden" ) ) {
          $('.has-item').css({'display':''});
          $('.no-item').css({'display':'none'});
        }
      }
      else {
        if ( $( ".no-item" ).is( ":hidden" ) ) {
          $('.has-item').css({'display':'none'});
          $('.no-item').css({'display':''});
        }
      }
      $('.modal.show').modal('hide');
      $('.offcanvas:not(.cart-offcanvas).show, #editOptsOffcanvas.show').offcanvas('hide');
    },
    success: function(table_content) {
      $('.mini-cart').removeClass('load');
      setTimeout(function(){
        $('.btn.adding').text(theme.strings.addToCart).removeClass('adding');
      },1000)
      var data = table_content.split('<!-- summary-discounts -->')
      table_content = data[0];
      if (data[1] && data[1].length > 0){
        $('.summary-discounts').html(data[1]).removeClass('d-none');
      } else {
        $('.summary-discounts').html(data[1]).addClass('d-none');
      }
      table.html(table_content).removeClass('loading');
      if(!remove_action && theme.function.type_ajax_cart == 'offcanvas'){
        $('#cartOffcanvas').offcanvas('show')
      }
      if(!remove_action && theme.function.type_ajax_cart == 'popup'){
        KT.popupOpen();
      }
      if($('.spendFreeShip').length > 0){
        var $spendFreeShip = $('.spendFreeShip');
        var line_total = parseInt($spendFreeShip.find('[aria-valuemax]').attr('aria-valuemax'));
        var progress_bar = $spendFreeShip.find('.progress-bar');
        if (line_total > cart.total_price){
          progress_bar.attr('aria-valuenow', line_total - cart.total_price).css('width',cart.total_price / line_total * 100 + '%').text(Math.round(cart.total_price / line_total * 100) + '%');
          $spendFreeShip.find('.text_progress .add_more_price').html(theme.function.threshold_cart.replace('#more', theme.Currency.formatMoney(line_total - cart.total_price, theme.moneyFormat)));
          $spendFreeShip.removeClass('congratulations');
        }else{
          progress_bar.attr('aria-valuenow', line_total).css('width','100%').text('100%');
          $spendFreeShip.addClass('congratulations');
        }
      }
      $('.title-ajax__cart').html(cart.item_count == 1 ? theme.strings.cartItem.split('(')[0]+'('+cart.item_count+' '+theme.strings.cartItemText+')'+theme.strings.cartItem.split(')')[1] : theme.strings.cartItems.split('(')[0]+'('+cart.item_count+' '+theme.strings.cartItemsText+')'+theme.strings.cartItems.split(')')[1]);
      $('.content__cart-offcanvas.loading, .mini-cart.loading').removeClass('loading');
    }
  });
}